import { MainInner } from "@/styles/global";
import styled from "styled-components";
import { Paragraph, Wysiwyg, h3, h5, h6 } from "@/styles/typography";

const Inner = styled(MainInner)`
  gap: 32px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled(h3)``;

const Ingress = styled(Paragraph)``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 48px;
    max-width: 800px;
  }
`;

const H5 = styled(h5)`
  text-align: left;
  margin-top: 4px;
`;

const H6 = styled(h6)`
  text-align: left;
`;

const AccTitleWrapper = styled.div``;

const TextBlock = styled.div`
  margin: 32px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &:first-child {
    margin-top: 0px;
  }
  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    &:first-child {
      margin-top: 8px;
    }
  }
`;

const Text = styled(Wysiwyg)`
  max-width: 780px;
  width: 100%;

  a {
    color: #002ab0;
    text-decoration: underline;
    border-bottom: none;
  }
`;

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  gap: 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 24px;
  }
`;

const Accordion = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.coreDark};
`;

const AccordionHeader = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 20px 24px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    padding: 28px 32px;
  }
`;

const AccordionArrow = styled.div<{ $isOpen: boolean }>`
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(-180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease-in-out;

  svg {
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    svg {
      width: 36px;
      height: 36px;
    }
  }
`;

const AccordionContent = styled.div<{ $isOpen: boolean }>`
  width: 100%;
  max-height: ${({ $isOpen }) => ($isOpen ? "1000px" : "0")};
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: ${({ $isOpen }) => ($isOpen ? " 0 20px 16px 20px;" : "0 20px")};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    padding: ${({ $isOpen }) => ($isOpen ? " 0 24px 20px 24px;" : "0 24px")};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    padding: ${({ $isOpen }) => ($isOpen ? " 0 32px 28px 32px;" : "0 32px")};
  }
`;

const VimeoHero = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;

  iframe {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
    border: none;
    background: ${({ theme }) => theme.colors.coreMedium};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 24px;
  }
`;

const S = {
  Inner,
  Title,
  Ingress,
  TextWrapper,
  Container,
  H5,
  H6,
  TextBlock,
  AccTitleWrapper,
  Text,
  AccordionWrapper,
  Accordion,
  AccordionHeader,
  AccordionArrow,
  AccordionContent,
  VimeoHero,
};

export default S;
